module.exports = __webpack_public_path__ + "static/media/file2.72e36495.jpg";